import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { PATH_CONSTANT } from "constant/PathConstant";
import { RowenaContent } from "pages/Tenant/AroDashboard/RowenaContent";

export function MyViewHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.startsWith(
    PATH_CONSTANT.TENANT.HOME_SEARCH
  )
    ? PATH_CONSTANT.TENANT.HOME_SEARCH
    : PATH_CONSTANT.TENANT.HOME;

  return (
    <Stack mb={1}>
      <Stack direction="row" gap={1} alignItems="center">
        <StarBorderOutlinedIcon fontSize="medium" sx={{ color: "#42BB93" }} />
        <Typography variant="body1" fontWeight="bold" color="text.primary">
          myView
        </Typography>
        <Box sx={{ ml: "auto" }}>
          <RowenaContent
            workFlowId="MY_VIEW"
            label="Rowena"
            tooltip="Open Rowena"
          />
        </Box>
      </Stack>
      <Tabs
        aria-label="Home sections"
        value={activeTab}
        onChange={(_, path: string) => navigate(path)}
        sx={{
          minHeight: 38,
          mt: 0.75,
          borderBottom: "1px solid #E4E7EC",
          "& .MuiTabs-indicator": {
            height: 2,
            backgroundColor: "#42BB93",
          },
          "& .MuiTab-root": {
            minWidth: 92,
            minHeight: 38,
            px: 2,
            py: 0.75,
            textTransform: "none",
            color: "#667085",
            fontSize: 14,
            fontWeight: 700,
          },
          "& .MuiTab-root.Mui-selected": {
            color: "#42BB93",
          },
        }}
      >
        <Tab label="Home" value={PATH_CONSTANT.TENANT.HOME} />
        <Tab label="AI Query" value={PATH_CONSTANT.TENANT.HOME_SEARCH} />
      </Tabs>
    </Stack>
  );
}
